import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';

const ExpandableSection = ({ title, children, defaultExpanded = true, overflow = 'hidden' }) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div className={`expandable-section border border-gray-300 rounded-md mb-4 overflow-${overflow} shadow-sm transition-all duration-200 hover:border-gray-400`}>
      <div
        className="section-header bg-gray-50 p-3 font-semibold flex justify-between items-center cursor-pointer rounded-t-md"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <h3 className="text-lg m-0 text-gray-700">{title}</h3>
        {isExpanded ? (
          <ChevronUpIcon className="h-5 w-5 text-primary" />
        ) : (
          <ChevronDownIcon className="h-5 w-5 text-primary" />
        )}
      </div>
      {isExpanded && (
        <div className="section-content p-4 bg-white rounded-b-md">
          {children}
        </div>
      )}
    </div>
  );
};

export default ExpandableSection; 